import { render, staticRenderFns } from "./NewsItems.vue?vue&type=template&id=00e509ce&scoped=true&"
import script from "./NewsItems.vue?vue&type=script&lang=js&"
export * from "./NewsItems.vue?vue&type=script&lang=js&"
import style0 from "./NewsItems.vue?vue&type=style&index=0&id=00e509ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e509ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e509ce')) {
      api.createRecord('00e509ce', component.options)
    } else {
      api.reload('00e509ce', component.options)
    }
    module.hot.accept("./NewsItems.vue?vue&type=template&id=00e509ce&scoped=true&", function () {
      api.rerender('00e509ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/NewsItems.vue"
export default component.exports